import React from 'react';
import MoveUnitItemFormDialog from './MoveUnitItemFormDialog';
import MoveUnitItemFormDialogService from '../../../services/MoveUnitItemFormDialogService';
import { observer } from 'mobx-react';

const MoveUnitItemFormDialogContainer = () => (
  <MoveUnitItemFormDialog
    isOpen={MoveUnitItemFormDialogService.isOpen}
    onCancel={MoveUnitItemFormDialogService.handleCancel}
    onConfirm={MoveUnitItemFormDialogService.handleConfirm}
    onChange={MoveUnitItemFormDialogService.handleChange}
    submitting={MoveUnitItemFormDialogService.submit.fetching}
    values={MoveUnitItemFormDialogService.form.getValues()}
    errors={MoveUnitItemFormDialogService.form.errors}
  />
);

export default observer(MoveUnitItemFormDialogContainer);
